import React, { Fragment } from 'react';
import { Card, Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { GQLParty } from '@jewelutions/core-crm-server-api-client-domain';
import { Box } from '../../../types-hack';

interface IProps {
  party: GQLParty;
}

const Support: React.FC<IProps> = ({ party }: IProps) => {
  const { t: translate } = useTranslation();

  return (
    <Fragment>
      <Grid container direction="row" spacing={4}>
        <Grid item xs={12}>
          <Card>
            <Box p={5}>
              <Typography gutterBottom variant="h6">
                {translate('sections.parties.partyUsers.users', 'Users')}
              </Typography>
              <p>
                Currently all merchant access happens via their webshop admin. Please use the Jewelutions shop
                app to login in the merchant backoffice. Please contact
                <a href="mailto:support@jewelutions.com?subject=[Merchant] Support request">
                  support@jewelutions.com
                </a>{' '}
                for any requests. Soon we will have an in place real time support system here.
              </p>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default Support;
